export const urlLastPathComponent = (url: string): string => {
  return (url.split('/').pop() ?? '').split('?')[0] ?? '';
};
